import { render, staticRenderFns } from "./Personalized.vue?vue&type=template&id=3cdeab68&scoped=true&"
import script from "./Personalized.vue?vue&type=script&lang=js&"
export * from "./Personalized.vue?vue&type=script&lang=js&"
import style0 from "./Personalized.vue?vue&type=style&index=0&id=3cdeab68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdeab68",
  null
  
)

export default component.exports